import { getVatRateAmount } from 'entities/Contract';
import { UserAccountType } from 'entities/User';
import { WarehouseForBooking } from 'entities/Warehouse';
import { roundNumber } from 'shared/utils/helpers/roundNumber';

export const getBoxPriceAmountWithVat = (
  price: Nullable<number> | undefined,
  warehouse: Nullable<WarehouseForBooking> | undefined,
  accountType?: Nullable<UserAccountType>,
): Nullable<number> => {
  if (!price || !warehouse) {
    return null;
  }

  let vatRatePercent;

  if (!accountType || accountType === UserAccountType.PERSONAL) {
    vatRatePercent = warehouse.personalVatRatePercent;
  }

  if (accountType === UserAccountType.BUSINESS) {
    vatRatePercent = warehouse.businessVatRatePercent;
  }

  const boxVatRateAmount = getVatRateAmount(price, vatRatePercent);
  const boxPriceWithVat = roundNumber(price + boxVatRateAmount);

  return boxPriceWithVat;
};
